// pages/PublicChatbot.tsx - Strona publiczna dla iframe
import React from 'react';
import { PublicChatWidget } from '../modules/chatbot/components/PublicChatWidget';

export const PublicChatbot: React.FC = () => {
  // Pobierz parametry z URL
  const params = new URLSearchParams(window.location.search);
  const config = {
    websiteId: params.get('websiteId') || 'default',
    position: (params.get('position') as any) || 'bottom-right',
    primaryColor: params.get('primaryColor') || '#3B82F6',
    title: params.get('title') || 'Potrzebujesz pomocy?',
    welcomeMessage: params.get('welcomeMessage') || 'Cześć! 👋 Jak mogę Ci pomóc?'
  };

  return (
    <div className="fixed inset-0 bg-transparent">
      <PublicChatWidget {...config} />
    </div>
  );
};